import React, { useEffect, useRef, useState } from "react";
import { withNamespaces } from "react-i18next";
import { withHeaderTitle } from "../../../components/Header/HeaderTitle";
import BlockUi from "react-block-ui";
import ChartCustom from "../../GoogleChart/ChartCustom";
import { getChart } from "../../../services/dashboardServices/serviceProblemGraphics";
// estilos.
import "react-block-ui/style.css";
import "../Dashboard.scss";

const IngresosScreen = (props) => {
  props.setHeaderTitle("Ingresos y problemas económicos");
  const isMounted = useRef(false);
  const [blocking, setBlocking] = useState(false);
  const filters = props.filters;
  const onSearch = props.onSearch;
  const setOnSearch = props.setOnSearch;
  // graficos
  const [columnsChart29, setColumnsChart29] = useState({ data: [], titles: [] }); 
  const [columnsChart29After, setColumnsChart29After] = useState({ data: [], titles: [] }); 
  const [columnsChart30, setColumnsChart30] = useState({ data: [], titles: [], format: 'FOR', referencias: {} }); 
  const [columnsChart32, setColumnsChart32] = useState({ data: [], titles: [], format: 'FOR', referencias: {} }); 
  const [columnsChart34, setColumnsChart34] = useState({ data: [], titles: [] }); 
  const [columnsChart49, setColumnsChart49] = useState({ data: [], titles: [], format: 'FOR', referencias: {} }); 

  const loadChar29 = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart29v1-mejorado" };
    const data = await getChart(config);
    const titles = generateTitles(data.medicionList);
    const rows = deletePropertyOnObjectList(data.rows);
    
    if (isMounted.current) {
      setColumnsChart29({ 
        data: rows, 
        titles: titles 
      });
    }
    
    setBlocking(false);
  };

  const loadChar29After = async () => {
    setBlocking(true);
    // console.log("AQUIIIII")
    const config = { params: filters, method: "GET", urlApi: "chart29v2-empeorado" };
    
    const data = await getChart(config);
    // console.log(data);
    const titles = generateTitles(data.medicionList);
    
    if (isMounted.current) {
      setColumnsChart29After({ 
        data: data.rows, 
        titles: titles 
      });
    }

    setBlocking(false);
  };

  const loadChar30 = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart30-ingresos" };
    const data = await getChart(config);
    const titles = [ 'Elección', '% Sí',  {role:'annotation'}, '% No',  {role:'annotation'},'% No responde', {role:'annotation'}];
    
    if (isMounted.current) {
      setColumnsChart30({ 
        data: data.rows, 
        titles: titles,
        format: 'FOR',
        referencias: data.referencias
      });
    }
    
    setBlocking(false);
  };

  const loadChar32 = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart32-finmes" };
    const data = await getChart(config);
    const titles = [ 'Elección', '% Bien',  {role:'annotation'}, '% Justo',  {role:'annotation'},'% No alcanza', {role:'annotation'}, '% Otros', {role:'annotation'}];
    
    if (isMounted.current) {
      setColumnsChart32({ 
        data: data.rows, 
        titles: titles,
        format: 'FOR2',
        referencias: data.referencias
      });
    }
    
    setBlocking(false);
  };

  const loadCharLife = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart34-problemas" };
    const data = await getChart(config);
    const titles = generateTitles(data.medicionList);
    
    if (isMounted.current) {
      setColumnsChart34({ 
        data: data.rows, 
        titles: titles 
      })
    }
    
    setBlocking(false);
  };

  const loadChar49 = async () => {
    setBlocking(true);
    const config = { params: filters, method: "GET", urlApi: "chart49" };
    const response = await getChart(config);
    // console.log("LOG...")
    // console.log(response)
    if (isMounted.current) {
      setColumnsChart49({ 
        ...columnsChart49, 
        data: response.rows, 
        format: 'FOR2',
        referencias: response.referencias
      });
    }
    
    setBlocking(false);
  };

  const generateTitles = (arr = []) => {
    return arr.reduce((acc, current) => {
      return acc = [ ...acc, `% ${current}`, {role:'annotation'} ]
    }, ['Elección']);
  }

  const deletePropertyOnObjectList = ( list = [], propertyToDlete = 'ORDEN' ) => {
    const newList = [];
    list.forEach(item => {
      let currentItem = item;
      if( currentItem[propertyToDlete] ){
        delete currentItem[propertyToDlete];
        newList.push(currentItem);
      }else{
        newList.push(currentItem);
      }
    });

    return newList;
  }

  const loadCharts = () => {
    loadChar29();
    loadChar29After();
    loadChar30();
    loadChar32();
    loadCharLife();
    loadChar49();
    setOnSearch(false);
  }

  useEffect(() => {
    isMounted.current = true;
    loadCharts();
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    loadCharts();
  }, [ onSearch ])
  
  return (
    <BlockUi tag="div" blocking={blocking}>
      {/* gráfico: lamina 29: actual */}
      <div className="row mb-2">
        {columnsChart29.data.length > 0 && (
          <ChartCustom 
            subTitle="¿Cuál de las siguientes alternativas describe mejor tu situación laboral actual?"
            dataChart={columnsChart29.data}
            titles={columnsChart29.titles} 
          />
        )}
      </div>

      {/* gráfico: lamina 29: año atras */}
      {/* <div className="row mb-2">
        {columnsChart29After.data.length > 0 && (
          <ChartCustom 
            subTitle="¿Y hace 1 año atrás, cuál era tu situación laboral?"
            dataChart={columnsChart29After.data}
            titles={columnsChart29After.titles} 
            chartComment='Pregunta no realizada en 2022.'
          />
        )}
      </div> */}
      
      {/* gráficos: Lamina 30 */} 
      {/* <div className="row mb-2">
        {columnsChart30.data.length > 0 && (
          <ChartCustom 
            subTitle="¿Han tenido que enfrentar en tu hogar disminuciones de ingreso de magnitud importante?"
            dataChart={columnsChart30.data}
            titles={columnsChart30.titles} 
            applyFormat={columnsChart30.format}
            referencias={columnsChart30.referencias}
            chartComment='Pregunta no realizada en 2022.'
          />
        )}
      </div>  */}

      {/* gráficos: Lamina 32 */} 
      <div className="row mb-2">
        {columnsChart32.data.length > 0 && (
          <ChartCustom 
            subTitle="Pensando en el ingreso total que obtienen hoy mensualmente en tu hogar, ¿Dirías que…? "
            sort={true}
            dataChart={columnsChart32.data}
            titles={columnsChart32.titles} 
            applyFormat={columnsChart32.format}
            referencias={columnsChart32.referencias}
          />
        )}
      </div>

      {/* gráfico lamina 34. */}
      <div className="row mb-2">
        {columnsChart34.data.length > 0 && (
          <ChartCustom 
            dataChart={columnsChart34.data}
            mathFilter='Con ninguno'
            subTitle="En los últimos 3 meses ¿En cuál de los siguientes ítems has tenido actualmente problemas para poder pagar?"
            titles={columnsChart34.titles} 
            chartConfig={{
              height: '70vh',
              chartArea: { width: "60%", height: '50%' }
            }}
          />
        )}
      </div>

      {/* gráficos: Lamina 49 */} 
      <div className="row mb-2">
        {columnsChart49.data.length > 0 && (
          <ChartCustom 
            subTitle="Aproximadamente, ¿Qué porcentaje menos de ingresos tiene hoy día su hogar a causa de la  crisis económica y el alza de precios?"
            chartComment="En 2021 se preguntó por la crisis del Coronavirus."
            dataChart={columnsChart49.data}
            applyFormat={columnsChart49.format}
            referencias={columnsChart49.referencias}
          />
        )}
      </div>

    </BlockUi>
  );
};

export default withNamespaces("translations")(withHeaderTitle(IngresosScreen));
